import { kilobaApi } from './api';

export interface GameConfig {
  quiz: {
    dailyPlayLimit: number;
    questionsPerGame: number;
    minimumCorrectAnswers: number;
    energyReward: number;
    description: string;
  };
  racing: {
    dailyPlayLimit: number;
    requiredScore: number;
    energyReward: number;
    description: string;
    remainingAttempts: number;
    canPlay: boolean;
    todayPlays: number;
    todaySuccessful: number;
  };
  clouds: {
    dailyPlayLimit: number;
    requiredScore: number;
    energyReward: number;
    description: string;
    remainingAttempts: number;
    canPlay: boolean;
    todayPlays: number;
    todaySuccessful: number;
  };
}

export class GameConfigService {
  /**
   * Get Kiloba Games configuration including energy rewards
   */
  static async getGameConfig(): Promise<GameConfig | null> {
    try {
      const response = await kilobaApi.getKilobaGamesConfig();
      
      if (response.success && response.data) {
        console.log('Game config fetched successfully:', response.data);
        return response.data;
      } else {
        console.error('Failed to fetch game config:', response.message);
        return null;
      }
    } catch (error) {
      console.error('Error fetching game config:', error);
      return null;
    }
  }

  /**
   * Get energy reward for specific game type
   */
  static getEnergyReward(config: GameConfig, gameType: 'quiz' | 'racing' | 'clouds'): number {
    return config[gameType]?.energyReward || 0;
  }

  /**
   * Check if user can play specific game
   */
  static canPlayGame(config: GameConfig, gameType: 'racing' | 'clouds'): boolean {
    return config[gameType]?.canPlay || false;
  }

  /**
   * Get remaining attempts for specific game
   */
  static getRemainingAttempts(config: GameConfig, gameType: 'racing' | 'clouds'): number {
    return config[gameType]?.remainingAttempts || 0;
  }
}
